module.exports = __webpack_public_path__ + "static/media/jquery.71eea9c9.png";